import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCog,
  faTimes,
  faInfoCircle,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../../common/LoadingSpinner";

function UserAssignmentModal({
  show,
  selectedUser,
  availableGroups,
  assignmentLoading,
  assignmentError,
  onGroupAssignment,
  onCancel,
}) {
  if (!show || !selectedUser) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content user-assignment-modal">
        <div className="modal-header">
          <h3>
            <FontAwesomeIcon icon={faUserCog} />
            Assign User to Group
          </h3>
          <button className="modal-close" onClick={onCancel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="modal-body">
          {assignmentError && (
            <div className="common-message error">
              <FontAwesomeIcon icon={faInfoCircle} />
              <span>{assignmentError}</span>
            </div>
          )}

          <div className="user-assignment-info">
            <h4>
              User: {selectedUser.firstName} {selectedUser.lastName}
            </h4>
            <p>Email: {selectedUser.email}</p>
            <p>
              Current Group: {selectedUser.groupName || "No group assigned"}
            </p>
          </div>

          {assignmentLoading ? (
            <div className="loading-container">
              <LoadingSpinner
                size="sm"
                message="Loading available groups..."
                className="compact"
              />
            </div>
          ) : (
            <div className="available-groups">
              <h4>Available Groups:</h4>
              {availableGroups.length > 0 ? (
                <div className="groups-list">
                  {availableGroups.map((group) => (
                    <div
                      key={group.groupName || group.name}
                      className="group-option"
                    >
                      <div className="group-info">
                        <div className="group-name">
                          <FontAwesomeIcon icon={faUsers} />
                          {group.name || group.groupName}
                        </div>
                        <div className="group-description">
                          {group.description || "No description"}
                        </div>
                      </div>
                      <button
                        className="common-button"
                        onClick={() =>
                          onGroupAssignment(group.groupName || group.name)
                        }
                        disabled={assignmentLoading}
                      >
                        Assign to Group
                      </button>
                    </div>
                  ))}

                  {/* Option to remove from group */}
                  <div className="group-option">
                    <div className="group-info">
                      <div className="group-name">
                        <FontAwesomeIcon icon={faTimes} />
                        Remove from Group
                      </div>
                      <div className="group-description">
                        Remove user from their current group
                      </div>
                    </div>
                    <button
                      className="common-button danger"
                      onClick={() => onGroupAssignment(null)}
                      disabled={assignmentLoading}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ) : (
                <div className="no-groups">
                  <p>No groups available for assignment.</p>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="common-button secondary"
            onClick={onCancel}
            disabled={assignmentLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserAssignmentModal;
